import { ApplicantStage } from 'src/graphql/types/applicants'
import { formatSnakeValue } from 'src/lib/formatters'
import { formatTerminatedReason } from 'src/lib/terminatedReason.utils'

const StageCell = ({ applicant }) => {
  const stageToField = {
    [ApplicantStage.PROSPECT]: 'hiringStage',
    [ApplicantStage.HIRED]: '',
    [ApplicantStage.NOT_INTERESTED]: 'notInterestedReason',
    [ApplicantStage.DISQUALIFIED]: 'disqualifiedReason',
    [ApplicantStage.TERMINATED]: 'terminatedReason',
    default: '',
  }

  const phaseField =
    stageToField[applicant.applicantStage] || stageToField.default

  // Terminated reasons have label overrides (e.g. "Company Policy"); other
  // stages' sub-reasons use the generic SNAKE_CASE → Title Case formatter.
  const formatPhaseValue =
    applicant.applicantStage === ApplicantStage.TERMINATED
      ? formatTerminatedReason
      : formatSnakeValue

  return (
    <div className="flex flex-col">
      <div className="text-xs font-medium capitalize text-doubleNickel-gray-900">
        {formatSnakeValue(applicant.applicantStage)}
      </div>
      {phaseField && (
        <div className="truncate text-xs font-medium text-doubleNickel-gray-600">
          {formatPhaseValue(applicant[phaseField])}
        </div>
      )}
    </div>
  )
}

export default StageCell
